export enum PresenceOrigin {
  PresenceSync = 'PresenceSync',
  Manual = 'Manual',
}
